import { JsonFileValueSourceIndicator } from './JsonFileValueSourceIndicator';

type UndecodedCalldataPanelProps = {
  calldata: string;
  value?: string | undefined;
  onClear?: (() => void) | undefined;
};

/**
 * Displays raw calldata when contract metadata is unavailable for decoding.
 */
export function UndecodedCalldataPanel({
  calldata,
  value,
  onClear,
}: UndecodedCalldataPanelProps): React.ReactElement {
  const hasNativeValue = value !== undefined && BigInt(value) > 0n;

  return (
    <section className="w-full overflow-hidden rounded-[22px] border border-white bg-neutral-50">
      <div className="flex items-center gap-[30px] px-5 py-5">
        <h3 className="text-[16px] font-medium text-zinc-900">Calldata</h3>
        <JsonFileValueSourceIndicator onClear={onClear} />
      </div>

      <div className="space-y-5 border-t border-zinc-200 px-5 py-6">
        <p className="text-[14px] leading-5 text-zinc-600">
          Please verify that the calldata is correct before you continue.
        </p>

        {hasNativeValue ? (
          <div className="flex items-center justify-between gap-4 rounded-[10px] border border-zinc-200 bg-white px-4 py-3">
            <span className="text-[13px] font-medium text-zinc-600">Value</span>
            <code className="min-w-0 break-all text-right text-[13px] text-zinc-900">
              {value} wei
            </code>
          </div>
        ) : null}

        <pre
          aria-label="Raw calldata"
          className="max-h-80 w-full overflow-auto whitespace-pre-wrap break-all font-mono text-[14px] font-semibold leading-5 text-zinc-900"
          tabIndex={0}
        >
          {calldata}
        </pre>
      </div>
    </section>
  );
}
